// extracted by mini-css-extract-plugin
export default {"productItemWrap":"eb6c322f7ca4","productLogo":"bbb2ed0f5995","connectionItemWrap":"f2080714a365","banner":"ea06991c0709"};